import dayjs from "dayjs"
import { MONTHS } from "../constant"

export const formatDate = (date: string | Date) => {
  return dayjs(date).isValid()
    ? dayjs(date).format("DD-MM-YYYY")
    : "___-__-____" // Fallback for invalid dates
}

export const formatTime = (date: string | Date) => {
  return dayjs(date).isValid() ? dayjs(date).format("hh:mm A") : "__:__ __" // Fallback for invalid times
}

export const formatDateTime = (date: string | Date) => {
  return dayjs(date).isValid()
    ? dayjs(date).format("DD-MM-YYYY hh:mm A")
    : "___-__-____ __:__ __"
}

export const formatMonthWithYear = (monthString: string) => {
  const [year, month] = monthString.split("-")
  const monthNum = parseInt(month)

  return `${MONTHS[monthNum - 1]}(${year})`
}
